import React from 'react';
import InputProps from './BusinessNameInput.types';
import styles from './BusinessNameInput.module.scss';

// Temporary stub component used for creating the schema only - to be remade
const BusinessNameInput = ({
  value,
  onChange,
  dataPointer,
  placeholder,
  id,
  dataCy = 'businessNameInput',
  invalid,
  errorMsgHolderId,
}: InputProps) => (
  <input
    defaultValue={value}
    className={styles.input}
    onChange={onChange}
    data-pointer={dataPointer}
    placeholder={placeholder || 'Business name'}
    id={id}
    data-lpignore
    data-cy={dataCy}
    aria-invalid={invalid}
    aria-errormessage={errorMsgHolderId}
  />
);

export default BusinessNameInput;
